import React, { useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { doForgotPassword } from '../../../modules/auth/stores/thunk';
import './Auth.scss';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ForgotPasswordForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { message } = useSelector((state) => state.common);

  useEffect(() => {
    if (message) {
      history.push('/');
    }
  }, [message]);

  const handleSubmit = (params) => {
    dispatch(doForgotPassword(params));
  };

  return (
    <div className="ForgotPasswordForm">
      <Form scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
        <div className="Logo">
          <Link to="/">
            <img src={`/logo.svg`} alt="logo" />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">Reset Password</div>
          <div className="SubTitle">Enter your email address to receive reset password instruction</div>
        </div>
        <div className="FormContent">
          <Form.Item
            label="Work Email"
            name="email"
            hasFeedback
            rules={[
              { type: 'email', message: 'Invalid Email' },
              { required: true, message: 'Required' },
            ]}
          >
            <Input size="large" placeholder="name@company.com" />
          </Form.Item>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            Send reset password link
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ForgotPasswordForm;
